// OP-3619 — O botão da câmera aparece onde há câmera.
//
// Tela de toque tem câmera, e a resposta sai no primeiro desenho, sem o botão
// surgir depois e empurrar a tela. No computador, pergunta-se ao navegador se
// há webcam — uma vez para a página inteira, e de novo quando um dispositivo é
// ligado ou desligado. Navegador que só lista dispositivos depois da permissão
// devolve lista vazia; aí o botão aparece, porque não há como saber.
import { useEffect, useState } from 'react'
import { eTelaDeToque } from './leitura'

let sondagem: Promise<boolean> | null = null
let observando = false
const ouvintes = new Set<(disponivel: boolean) => void>()

const midia = (): MediaDevices | undefined => (typeof navigator === 'undefined' ? undefined : navigator.mediaDevices)

function respostaImediata(): boolean | null {
  const md = midia()
  if (!md || !md.getUserMedia) return false
  if (eTelaDeToque()) return true
  return null
}

function sondar(): Promise<boolean> {
  const md = midia()
  if (!md || !md.enumerateDevices) return Promise.resolve(false)
  if (!sondagem) {
    sondagem = md.enumerateDevices()
      .then((dispositivos) => dispositivos.length === 0 || dispositivos.some((d) => d.kind === 'videoinput'))
      .catch(() => false)
      .then((disponivel) => {
        ouvintes.forEach((avisar) => avisar(disponivel))
        return disponivel
      })
  }
  return sondagem
}

function observarMudancas(): void {
  const md = midia()
  if (observando || !md || typeof md.addEventListener !== 'function') return
  observando = true
  md.addEventListener('devicechange', () => {
    sondagem = null
    sondar()
  })
}

export function useCameraDisponivel(): boolean {
  const [disponivel, setDisponivel] = useState<boolean>(() => respostaImediata() ?? false)
  useEffect(() => {
    if (respostaImediata() !== null) return undefined
    let vivo = true
    const avisar = (v: boolean) => { if (vivo) setDisponivel(v) }
    ouvintes.add(avisar)
    observarMudancas()
    sondar().then(avisar)
    return () => {
      vivo = false
      ouvintes.delete(avisar)
    }
  }, [])
  return disponivel
}
